import { Component, Input, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { DataDay } from '@classes/dashboard/dashboard';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { CompareDateService } from '@services/compare-date/compare-date.service';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {

  @Input() day: string;
  @Input() data: DataDay[];
  @Input() camera: string;
  @Input() dateStart: Date;
  @Input() dateEnd: Date;
  @Input() dateLabel: Date;
  @Input() labelOrderly: string;
  @Input() typeChart: string;

  faInfoCircle = faInfoCircle;

  from: string;
  to: string;

  color: ThemePalette = 'primary';

  public barChartOptions = {
    responsive: true,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 50
      },

    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
        }
      }]
    }
  };
  public barChartLabels = ['0h', '1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h', '9h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h'];
  colorLabel: string[] = [];
  colorLabelHover: string[] = [];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData = [];
  dateDiff: number;
  infoBubble: string;

  constructor(
    private compareDate: CompareDateService
  ) { }

  ngOnInit(): void {

    const dateEnd = new Date(this.dateEnd);
    dateEnd.setDate(dateEnd.getDate() + 1);
    this.dateDiff = this.compareDate.compareTwoDate(this.dateStart, dateEnd);

    // if (this.dateDiff <= 8) {
    //   this.dateStart.setDate(this.dateStart.getDate() + 1);
    // }



    const dataParking = [];

    this.data.forEach(item => {
      dataParking.push(item.value);
    });

    this.colorLabel = this.getColorLabel('notHover');
    this.colorLabelHover = this.getColorLabel('hover');

    this.barChartData = [
      { data: dataParking, backgroundColor: this.colorLabel, hoverBackgroundColor: this.colorLabelHover, label: this.camera },
    ];

    this.getSum();
    this.getTextInfo();

  }



  getSum(): number {
    const total = Object.values(this.data).reduce((t, { value }) => t + value, 0);
    return total;
  }

  private getTextInfo(): void {
    switch (this.typeChart) {
      case 'carSuction':
        this.infoBubble = 'Ce tableau reprend le cumule des véhicules ayant dépassé le temps de stationnement réglementaire par heure. Si la limite est d\'une heure, un véhicule qui se stationne à 11h et qui dépasse le temps réglementaire de 3 heures, il sera repris dans les statistiques à partir de 12h jusque 15h.';
        break;
      case 'occupancyRate':
        this.infoBubble = 'Ce tableau reprend l\'occupation moyenne des places de parking par heure.';

        break;

      default:
        break;
    }
  }

  private getColorLabel(type: string): string[] {
    const timeLabel = 24;
    const colorLabel: string[] = [];
    const color = type === 'hover' ? '#0074c8' : '#0075c8b2';

    for (let i = 0; i < timeLabel; i++) {
      colorLabel.push(color);

    }

    return colorLabel;

  }

}
